import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // noteGuids: [],
    // notes: [],
    // query: {},
    totalNotes: 0,
    resources: {},
    resourceHashes: [],
    resourceHashIndex: 0,
    recentNotesContext: undefined,
    noteDetailContext: undefined,
    selectedConditionGuid: undefined,
    previousNotebookGuidOfConditions: undefined,
    previousTagGuidsOfConditions: [],
    optionKeyword: undefined,
    numberOfAds: 0,
    nocache: false
  },
  getters: {},
  actions: {},
  mutations: {
    // setNoteGuids(state, noteGuids) {
    //   state.noteGuids = noteGuids
    // },
    // setNotes(state, notes) {
    //   state.notes = notes
    // },
    // setQuery(state, query) {
    //   state.query = query
    // },
    setTotalNotes(state, totalNotes) {
      state.totalNotes = totalNotes
    },
    setResources(state, resources) {
      state.resources = resources
    },
    setResourceHashes(state, resourceHashes) {
      state.resourceHashes = resourceHashes
    },
    setResourceHashIndex(state, resourceHashIndex) {
      state.resourceHashIndex = Number(resourceHashIndex)
    },
    setRecentNotesContext(state, recentNotesContext) {
      state.recentNotesContext = recentNotesContext
    },
    setSelectedConditionGuid(state, selectedConditionGuid) {
      state.selectedConditionGuid = selectedConditionGuid
    },
    setPreviousNotebookGuidOfConditions(state, guid) {
      state.previousNotebookGuidOfConditions = guid
    },
    setPreviousTagGuidsOfConditions(state, guids) {
      state.previousTagGuidsOfConditions = guids
    },
    setOptionKeyword(state, optionKeyword) {
      state.optionKeyword = optionKeyword
    },
    setNumberOfAds(state, value) {
      state.numberOfAds = value
    },
    setNocache(state, value) {
      state.nocache = value
    }
  }
})
